import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from 'enova-frontend-components';

export const EnumRadioButton: FC<{
  value: string;
  i18nPrefix: string;
  hasHelperText?: boolean;
}> = ({ value, i18nPrefix, hasHelperText }) => {
  const { t } = useTranslation();

  return (
    <Radio
      width="auto"
      value={value}
      aria-label={t(`${i18nPrefix}.${value}`)}
      label={t(`${i18nPrefix}.${value}`)}
      helperText={hasHelperText && t(`${i18nPrefix}.${value}.helperText`)}
    />
  );
};
